export default __webpack_public_path__ + "static/media/radish-button-5.7c5b2aca.png";